export const TASK_TYPE = {
  main: 1,
  son: 2,
};
